import { render, staticRenderFns } from "./ImportContactsWithLabelsModal.vue?vue&type=template&id=4318e6ec&"
import script from "./ImportContactsWithLabelsModal.vue?vue&type=script&lang=js&"
export * from "./ImportContactsWithLabelsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports